import { Component } from '@angular/core';
import {AppConfig} from './_config'
import { SPINNER } from 'ngx-ui-loader';
import * as moment from 'moment';
import { FirebaseService } from 'src/app/services/firebase.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'customer-led-dao';
  logo = '';
  banner= '';
  mainPage=true;
  public loader:any ={};

  constructor(private appConfig:AppConfig, public firebase:FirebaseService){
    this.logo = appConfig.logoPath;
    this.banner = appConfig.bannerPath;
    this.configureLoader();
    firebase.InitializeFirebase();
    Date.prototype.toJSON = function(){ return moment(this).format('YYYY-MM-DDTHH:mm:ss'); }

  }

  configureLoader(){
    this.loader = {
      fgsLoaderType:SPINNER.fadingCircle,
      loaderText: "Please wait...",
      logoPath: "assets/images/symbol.png",
      blur:5
    }
  }

}
